import type { ReactNode } from "react";

interface AlertProps {
  variant: "error" | "info" | "warning" | "success";
  children: ReactNode;
}

/** A coloured banner for error/info/warning/success messaging, used throughout the screens. */
export function Alert({ variant, children }: AlertProps): JSX.Element {
  return (
    <div className={`alert alert--${variant}`} role={variant === "error" ? "alert" : "status"}>
      {children}
    </div>
  );
}
